export default "__VITE_ASSET__a41de64e__"